<template>
    <q-card flat class="bg-grey-2" @click="selectPoints">
      <q-card-section class="q-ma-xs q-pa-xs">
        <q-item class="q-px-none q-ma-xs">
          <q-item-section avatar>
            <q-avatar size="50px">
              <img v-if="perk.place && perk.place.logo" :src="logoSrc">
              <img src="../assets/icon.png" v-else>
            </q-avatar>
          </q-item-section>
          <q-item-section >
            <q-item-label class="text-h6 text-left" v-if="!merchant">{{perk.place.name}}</q-item-label>
            <q-item-label class="text-h6 text-left" v-else>{{perk.name}}</q-item-label>
            <q-item-label class="text-caption text-left">
              <q-icon name="history"></q-icon> last point earned {{updatedAtAgo}}
            </q-item-label>
            <q-item-label class="text-caption text-left" v-if="perks - points > 0">Only {{perks - points}} more to get there</q-item-label>
          </q-item-section>
        </q-item>
        <div caption :class="'row justify-center q-ma-sm q-gutter-sm'">
          <q-avatar color="primary" size="md" text-color="white" v-for="item in getPoints" :key="item" ></q-avatar>
          <template v-if="points <= perks">
            <q-avatar color="grey-1" size="md" text-color="primary" v-for="item in getPerks" :key="item" style="border-style: solid;border-color: #ec4080;"> </q-avatar>
          </template>
          <q-avatar color="white" size="md" text-color="primary"  v-if="points > perks">{{(points - perks) + '+'}}</q-avatar>
        </div>
        <div class="text-bold q-my-sm" v-if="points - perks >= 0">
        <q-img color="primary" width="10%" src="/assets/icon-app/android-icon-144x144.png"></q-img> Hooray! You have a perk to collect!
        </div>
      </q-card-section>
    </q-card>
</template>
<script>
import router from "@/router"
import { useStore } from 'vuex'
import { computed, nextTick } from '@vue/runtime-core'
export default {
  props: ['perk', 'points', 'list', 'cssclass', 'perks', 'updatedAtAgo', 'merchant'],
  setup(props) {
    const store = useStore()
    const logoSrc = computed(() => process.env.VUE_APP_URL + props.perk.place.logo.contentUrl)
    const getPoints = computed(() => {
      if (!props.points || props.points < 0) return 0
      if (props.points > props.perks) return props.perks
      return props.points
    })
    const getPerks = computed(() => {
      if (!props.perks || (props.perks + 1) > 10 || props.perk < 0) return 10
      else if(props.points) return props.perks - props.points
      return props.perks
    })

    const getProgress = computed(() => {
      let points = this.points
      let perks = this.perks
      return points / perks
    })

    const getUpdate = computed(() => {
      let today = new Date()
      if (!props.perk || props.perk < 0) return
      var diff = (today.getTime() - new Date(props.perk.updatedAt))
      var seconds = diff / 1000;
      var days = diff / (1000*3600*24)

      if (seconds <= 120) return ' just now'
      else if (days <= 1) return ' today'
      else if (days >= 1 && days <= 2) return ' yesterday'
      else return new Date(props.perk.updatedAt).toLocaleString()
    })

    const selectPoints = async () => {
        store.commit('setHPlace', props.perk.place)

        if (props.merchant) {
          store.commit('setHUser', {
            id: props.perk.ownerId,
            name: props.perk.name ?? 'Anonymous'
          })

          await nextTick()
          
          router.push('/points/history/merchant')
        }
        else {
          store.commit('setHUser', {
            id: props.perk.ownerId
          })

          await nextTick()
          
          router.push('/points/history')
        }
    }
    
    return {selectPoints, logoSrc, getPoints, getPerks, getUpdate, getProgress}
  },
}
</script>
<style scoped>
.my-card {cursor: pointer;}
</style>
